import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { isMobile } from 'react-device-detect';

import GroupShowStore from '../../store/GroupShowStore';
import LiveBroadcastStore from '../../store/LiveBroadcastStore';

import styles from './css/LiveBanner.module.css';


const AnchorLiveFeed = React.lazy(() => import('../anchorComponents/AnchorLiveFeed/AnchorLiveFeed'));


@observer
class LiveBanner extends Component {
  constructor(...args) {
    super(...args);
    const { user, extractIdFromSlug } = this.props;
    const { authenticated } = user;
    let existingSubscription = undefined;
    if (authenticated) {
      const { user: { account } } = user;
      const { anchorSubscriptions } = account || {};
      const checkId = extractIdFromSlug();
      existingSubscription = anchorSubscriptions?.find((sub) => sub.subCategory === checkId);
    }

    this.state = { isSubscribed: Boolean(existingSubscription) };
  }

  onClick = () => this.props.openContextualOverlay(true);

  bannerInfoAndCta = (className) => {
    const { nakedNewsLiveAnchorData } = this.props;
    const { image, promopic } = nakedNewsLiveAnchorData || {};
    const bannerImage = className === 'desktop' ? image : promopic;
    const { isSubscribed } = this.state;
    const url = !isSubscribed ? '/account/purchase?_anchor=241&_shortUrl=live' : '#';
    if (!bannerImage) {
      return null;
    }
    const dotIndex = bannerImage.lastIndexOf('.');
    const isVideo = bannerImage.substring(dotIndex) === '.mp4';

    return (
      <a
        className={styles[className]}
        href={url}
      >
        {
          isVideo &&
          <video
            autoPlay={!isMobile}
            className={styles.videoPlayerBanner}
            loop={true}
            muted={true}
            src={bannerImage}
          />}
        {!isVideo && <img alt="Naked News Live" src={bannerImage} />}
        <div className={styles.anchorSubscribeButton}>
          {!isSubscribed && (
            <button
              className={styles.joinNow}
              onClick={this.onClick}
            >
              SIGN UP NOW
            </button>)}
        </div>
      </a>
    );
  };

  render() {
    const {
      anchor,
      anchorVideoUrl,
      user,
      chatService,
      chatServiceTempted,
      guestUser,
      anchorId,
      openContextualOverlay,
      galleriesAndVideosCount,
      slug,
      history,
      isSpotlighing,
      spotlighedAnchorUsername,
      spotlighedAnchorNickname,
      isLivePage,
      fetchStreamDetails,
      isBanned,
      onNetworkError,
    } = this.props;
    const { isSubscribed } = this.state;
    const isWhitelisted = user?.features.includes('ANCHOR_PORTAL');
    const isAnchor = user?.user?.account.anchor;
    const anchorIsActive = anchor.active;
    const onProbation = parseInt(anchorId, 10) === 120;
    const { isInGroupShow } = GroupShowStore;
    const { streamStarted } = LiveBroadcastStore;
    const shouldShowStream = streamStarted && ((anchorVideoUrl && isWhitelisted) || isInGroupShow);
    const canSubscribeToAnchor = !isAnchor && !onProbation && !isSubscribed && isWhitelisted && anchorIsActive && galleriesAndVideosCount > 0;

    return (
      <div className="masthead">
        {shouldShowStream && (
          <React.Suspense fallback={null}>
            <AnchorLiveFeed
              anchor={anchor}
              anchorId={anchorId}
              anchorVideoUrl={anchorVideoUrl}
              background={anchor?.promopic}
              canSubscribeToAnchor={canSubscribeToAnchor}
              chatService={chatService}
              chatServiceTempted={chatServiceTempted}
              fetchStreamDetails={fetchStreamDetails}
              guestUser={guestUser}
              history={history}
              isAlreadySubscribedToAnchor={isSubscribed}
              isAnchor={isAnchor}
              isBanned={isBanned}
              isInGroupShow={isInGroupShow}
              isLivePage={isLivePage}
              isSpotlighing={isSpotlighing}
              isWhitelisted={isWhitelisted}
              openContextualOverlay={openContextualOverlay}
              slug={slug}
              spotlighedAnchorNickname={spotlighedAnchorNickname}
              spotlighedAnchorUsername={spotlighedAnchorUsername}
              user={user}
              onNetworkError={onNetworkError}
            />
          </React.Suspense>
        )}
        <div className="container">
          <div
            className={styles.liveBanner}
          >
            {this.bannerInfoAndCta('desktop')}
          </div>
          {this.bannerInfoAndCta('mobile')}
        </div>
      </div>
    );
  }
}

export default LiveBanner;
